import { useState } from "react";
import messages from "messages";
// styles
import styles from "./styles.module.scss";
// components
import { ReactComponent as OutlineDownload } from "assets/svg/outline-download.svg";
import { ReactComponent as OutlineTrash1 } from "assets/svg/outline-trash-1.svg";
import { ReactComponent as OutlineCross } from "assets/svg/outline-cross.svg";
import { ReactComponent as OutlineFolderMoveTo } from "assets/svg/outline-folder-move-to.svg";
import { BatchEntryOpsFunc } from "contexts/orchid-drive/components/orchidDriveProvider";
import IconButton from "components/icon-button";
import ErrorTag from "components/error-tag";
// utils
import getClasses from "utils/getClasses";
// types
import type { SelectedItem } from "../..";
import { AmplitudePageName, track } from "utils/amplitude";

type Props = {
  batchEntryOps: BatchEntryOpsFunc;
  selected: SelectedItem[];
  onDownload: () => void;
  onMove?: () => void;
  onCancel: () => void;
  storageDrive: StorageDrive;
  analyticsPageName: AmplitudePageName;
  analyticsComponentName: string;
};
const MultiselectBar = ({
  batchEntryOps,
  selected,
  onDownload,
  onMove,
  onCancel,
  storageDrive,
  analyticsPageName,
  analyticsComponentName,
}: Props) => {
  const [showDeletedTag, setShowDeletedTag] = useState(false);

  let entryToDelete = [] as any;
  selected.map((el) => entryToDelete.push({ entryId: el.guid }));

  return !selected.length ? null : (
    <>
      <ErrorTag
        show={showDeletedTag}
        onHide={() => setShowDeletedTag(false)}
        duration={3000}
        errorMsg={"Deleted"}
      />
      <div
        className={styles["multiselect-bar"]}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <span>
          {`${selected.length} ${
            selected.length === 1 ? messages.item : messages.items
          } ${messages.selected}`}
        </span>

        <div className={getClasses(styles["multiselect-bar__actions"])}>
          {onDownload && (
            <IconButton
              className={styles["multiselect-bar__action"]}
              onClick={() => {
                track(
                  analyticsPageName,
                  [analyticsComponentName, "download-button"],
                  "click",
                );
                onDownload();
              }}
              // // TODO: will be added in the new rev of BE api response
              // disabled={true}
            >
              <OutlineDownload />
            </IconButton>
          )}
          {storageDrive !== "note-attachment" && (
            <IconButton
              className={styles["multiselect-bar__action"]}
              onClick={() => {
                track(
                  analyticsPageName,
                  [analyticsComponentName, "trash-button"],
                  "click",
                );
                batchEntryOps({
                  entryMoves: [],
                  entryDeletes: entryToDelete,
                });
                setShowDeletedTag(true);
              }}
            >
              <OutlineTrash1 />
            </IconButton>
          )}
          {onMove && (
            <IconButton
              className={styles["multiselect-bar__action"]}
              onClick={() => {
                track(
                  analyticsPageName,
                  [analyticsComponentName, "move-to-folder-button"],
                  "click",
                );
                onMove();
              }}
            >
              <OutlineFolderMoveTo />
            </IconButton>
          )}
          <IconButton
            className={styles["multiselect-bar__action"]}
            onClick={() => {
              track(
                analyticsPageName,
                [analyticsComponentName, "cancel-button"],
                "click",
              );
              onCancel();
            }}
          >
            <OutlineCross />
          </IconButton>
        </div>
      </div>
    </>
  );
};

export default MultiselectBar;
